import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import TopBar from './components/TopBar';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Advantages from './components/Advantages';
import FAQ from './components/FAQ';
import CitiesAndArticles from './components/CitiesAndArticles';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';
import ServicePage from './pages/ServicePage';
import { BlogList, BlogPost } from './pages/Blog';
import { ContactPage, CityPage } from './pages/ContactAndCity';
import AboutPage from './pages/AboutPage';
import AdminPanel from './pages/AdminPanel';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function HomePage() {
  return (
    <>
      <Hero />
      <About />
      <Advantages />
      <FAQ />
      <CitiesAndArticles />
    </>
  );
}

function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <TopBar />
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
        <Route path="/services/:slug" element={<PublicLayout><ServicePage /></PublicLayout>} />
        <Route path="/blog" element={<PublicLayout><BlogList /></PublicLayout>} />
        <Route path="/blog/:slug" element={<PublicLayout><BlogPost /></PublicLayout>} />
        <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
        <Route path="/city/:city" element={<PublicLayout><CityPage /></PublicLayout>} />
        <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
        <Route path="*" element={<PublicLayout><HomePage /></PublicLayout>} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
